import { useMemo } from 'react';
import type { PasswordValidation } from '../types';

/**
 * 密码验证 Hook
 * @param password 密码字符串
 * @returns PasswordValidation
 */
export function usePasswordValidation(password: string): PasswordValidation {
  return useMemo(() => {
    const lengthValid = password.length >= 8 && password.length <= 20;
    const hasNumber = /\d/.test(password);
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumberAndLetter = hasNumber && hasLetter;

    return {
      lengthValid,
      hasNumberAndLetter,
    };
  }, [password]);
}

/**
 * 检查密码是否完全有效
 */
export function isPasswordValid(validation: PasswordValidation): boolean {
  return validation.lengthValid && validation.hasNumberAndLetter;
}

export default usePasswordValidation;
